import script from "./GlobalHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./GlobalHeader.vue?vue&type=script&lang=ts&setup=true"

import "./GlobalHeader.vue?vue&type=style&index=0&id=e34be960&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e34be960"]])

export default __exports__